
























import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IProduct } from "@/models/products";
import { IBasketProduct } from "@/models/baskets";

@Component
export default class ProductTrial extends Vue {
  // Prop

  @Prop({ required: true })
  public value!: boolean;

  @Prop({ required: true })
  public product!: IProduct;

  @Prop({ default: false })
  public isDisabled!: IProduct;

  @Prop({ default: null })
  public basketProduct!: IBasketProduct;

  // Getters

  public get useTrial() {
    return this.value;
  }

  // Setters

  public set useTrial(value) {
    this.$emit("input", value);
  }

  // Life-cycle methods

  public created() {
    this.$set(
      this,
      "useTrial",
      this.basketProduct?.in_trial ?? this.product.trial_supported
    );
  }

  // Computed

  public get productEntity() {
    return this.$store.getters[`data/${DataModules.CATALOGUE}/entity`](
      this.product
    );
  }

  public get productTrialDuration() {
    return this.product.trial_duration;
  }

  public get trialIsDisabled() {
    return this.isDisabled || this.product.trial_force;
  }
}
